<template>

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar title="Mapa de Produção" exibeVoltar="true" historyback="false" 
            @navigate="navigate" navigateto="mapaproducao"/>
        </div>
        <div class="app-centro">
            <div v-if="mensagem" class="msg-error">
                <center>
                    <br/><i class="fas fa-exclamation-triangle"></i> {{mensagem}}
                </center>
            </div>
            
            <div class="div-titulo" v-if="mapa.mapa.length">
                <div class="label-titulo" style="border-bottom: 1px solid var(--dark-color); border-right: 1px solid var(--dark-color); float: left; width: 140px; text-align: center;">Venda</div>                    
                <div class="label-titulo" style="border-bottom: 1px solid var(--dark-color); border-right: 1px solid var(--dark-color); float: left; width: 140px; text-align: center;">Data. Lct</div>
                <div class="label-titulo" style="border-bottom: 1px solid var(--dark-color); border-right: 1px solid var(--dark-color); float: left; width: 90px; text-align: center;">Produto</div>
                <div class="label-titulo" style="border-bottom: 1px solid var(--dark-color); border-right: 1px solid var(--dark-color); float: left; width: 110px; text-align: center;">Fornecedor</div>
                <div class="label-titulo" style="border-bottom: 1px solid var(--dark-color); border-right: 1px solid var(--dark-color); float: left; width: 140px; text-align: center;">Cliente</div>
                <div class="label-titulo" style="border-bottom: 1px solid var(--dark-color); border-right: 1px solid var(--dark-color); float: left; width: 100px; text-align: center;">Tarifa</div>
                <div class="label-titulo" style="border-bottom: 1px solid var(--dark-color); border-right: 1px solid var(--dark-color); float: left; width: 100px; text-align: center;">Taxa</div>
                <div class="label-titulo" style="border-bottom: 1px solid var(--dark-color); float: left; width: 100px; text-align: center;">Lucro</div>
            </div>          

            <div class="item-lista2 item-mapa"  v-for="item in mapa.mapa" v-bind:key="item.ID_VS">
                <div style="float: left; width: 70px; text-align: center;">{{ item.ID_VS }}</div>
                <div style="border-right: 1px solid #CECECE; float: left; width: 70px; text-align: center;"><button @click="abrirvenda(item.ID_VS)" class="botao-pesquisa-mapa-producao"><i class="fas fa-search  fa-lg"></i></button></div>
                <div style="border-right: 1px solid #CECECE; float: left; width: 140px; text-align: center;">{{item.DATA_LCT | moment("DD/MM/YYYY")}}</div>
                <div style="border-right: 1px solid #CECECE; float: left; width: 90px;">{{item.COD_PRODUTO}}</div>
                <div style="border-right: 1px solid #CECECE; float: left; width: 110px;">{{item.COD_FORNEC}}</div>
                <div style="border-right: 1px solid #CECECE; float: left; width: 140px;">{{item.NOME_CLIENTE}}</div>
                <div style="border-right: 1px solid #CECECE; float: left; width: 100px; text-align: right;"><span-valor :valor="item.TARIFA"/></div>
                <div style="border-right: 1px solid #CECECE; float: left; width: 100px; text-align: right;"><span-valor :valor="item.TAXA"/></div>
                <div style="float: left; width: 100px; text-align: right;"><span-valor :valor="item.LUCRO"/></div>
            </div>  

            <div class="item-lista2 item-mapa total-geral"  v-if="mapa.total_geral">
                <div style="float: left; width: 625px; text-align: right;">Total Geral:&nbsp;</div>
                <div style="border-right: 1px solid var(--primary-color); float: left; width: 100px; text-align: right;"><span-valor :valor="mapa.total_geral.total_tarifa"/></div>
                <div style="border-right: 1px solid var(--primary-color); float: left; width: 100px; text-align: right;"><span-valor :valor="mapa.total_geral.total_taxa"/></div>
                <div style="float: left; width: 100px; text-align: right;"><span-valor :valor="mapa.total_geral.total_prev_lb"/></div>
            </div>
        </div>
        <div class="app-rodape">

            <div class="paginacao" v-if="paginas>0">
                <div class="paginacao-left">
                    <button @click="primeirapagina"><i class="fas fa-angle-double-left"></i></button>
                    <button @click="paginaanterior"><i class="fas fa-angle-left"></i></button>
                </div>
                <div class="paginacao-centro">Página {{mapa.pagina}}/{{paginas}}</div>
                <div class="paginacao-right">
                    <button @click="proximapagina"><i class="fas fa-angle-right"></i></button>
                    <button @click="ultimapagina"><i class="fas fa-angle-double-right"></i></button>
                </div>
            </div>

        </div>
        
	</div>

</template>

<script>

import TopBar from '@/components/layout/TopBar.vue';
import request from '@/services/services.js';
import SpanValor from '@/components/shared/SpanValor.vue';


export default {
    name : 'MapaProducao',
    components: {TopBar, SpanValor},
    props: ["dtinicio","dtfim","pagina"],

    data(){
        return {
            mensagem : '',
            paginas : 0,
            mapa : {
                itensPorPagina: 15, 
                pagina: 1, 
                total: 0, 
                mapa: []
            }
        }
    },

    mounted(){

        this.pesquisar(this.pagina);
        
    },

    methods : {
        navigate(){
            this.$router.push(`/financeiro/mapaproducao`);
        },
        abrirvenda(venda){
            this.$router.push(`/mapaproducao/venda/${venda}`);
        },
        primeirapagina(){
            if(this.mapa.pagina!=1){
                this.mapa.pagina = 1;
                this.$router.push(`/mapaproducao/${encodeURIComponent(this.dtinicio)}/${encodeURIComponent(this.dtfim)}/${this.mapa.pagina}`);
                this.pesquisar(this.mapa.pagina);
            }
        },
        ultimapagina(){
            if(this.mapa.pagina!=this.paginas){
                this.mapa.pagina = this.paginas;
                this.$router.push(`/mapaproducao/${encodeURIComponent(this.dtinicio)}/${encodeURIComponent(this.dtfim)}/${this.mapa.pagina}`);
                this.pesquisar(this.mapa.pagina);
            }
        },
        paginaanterior(){
            if(this.mapa.pagina>1){
                this.mapa.pagina--;
                this.$router.push(`/mapaproducao/${encodeURIComponent(this.dtinicio)}/${encodeURIComponent(this.dtfim)}/${this.mapa.pagina}`);
                this.pesquisar(this.mapa.pagina);
            }
        },
        proximapagina(){
            if(this.mapa.pagina<this.paginas){
                this.mapa.pagina++;
                this.$router.push(`/mapaproducao/${encodeURIComponent(this.dtinicio)}/${encodeURIComponent(this.dtfim)}/${this.mapa.pagina}`);
                this.pesquisar(this.mapa.pagina);
            }
        },
        pesquisar(pagina){
            request(this, 'GET',
                'Mobile_MapaProducao',
                `id_filial=${this.$root.getFilial()}&dt1=${encodeURIComponent(this.dtinicio)}&dt2=${encodeURIComponent(this.dtfim)}&p=${pagina}`)
                .then(res => {
                    if(res){
                        this.mapa = res;

                        if(!this.mapa.mapa.length){
                            this.mensagem  = 'Nenhuma venda encontada!'
                        } else {
                            this.paginas = Math.ceil(this.mapa.total/this.mapa.itensPorPagina);
                        }
                    }
                });

        }

    }

    
}
</script>

<style scoped>

    .mapaproducao{
        height: calc(100vh - 140px);
        overflow: auto;
        width: 100%; 
    }

    .div-titulo{
        height: 45px;
        line-height: 45px;
        background-color: var(--primary-color);
        color: white;
        --padding: 10px;
        width: 927px;
    }    

    .item-lista2{
   
        width: 100%;
        --box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);  
        height: 50px;
        border-top: 1px solid #CECECE;
        line-height: 50px;
        background-color: #fafafa;
        font-size: 16px;
    }

    .lista-mapa{
        width: 927px;
        overflow: auto;
    }

    .item-mapa{
        width: 927px;
        height: 50px;
    }

    .total-geral{
        background-color: var(--light-color);
        font-weight: bold;

    }

    .paginacao{
        background-color: var(--primary-color);
        display: table;
        width: 100%;
        height: 50px;
    }

    .paginacao-left{
        width: 30%;
        float: left;
    }

    .paginacao-left button, .paginacao-right, button {
        border: 0px solid;
        background-color: var(--primary-color);
        width: 50%; 
        color: white;
        font-size: 18px;
        height: 50px;
    }

    .botao-pesquisa-mapa-producao{
        font-size: 12px;
        border-radius: 10px;

        background-color: var(--primary-color);
        border: 0px;		

        transition: all  0.2s ease-in-out;		

        padding: 5px;
        width: 50px;
        color: #FFFFFF;
        height: 34px;
        margin-top: -10px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }

    .paginacao-centro{
        width: 40%;
        float: left;
        height: 50px;
        text-align: center;
        color: white;
        font-size: 18px;
        line-height: 50px;
    }

    .paginacao-right{
         width: 30%;
         float: right;
    }
    



</style>